import styled from 'styled-components'
import bg2Img from '../../assets/bg2.png'
import logo2Img from '../../assets/logo2.png'
function Page0Mobile(props) {
  let banner = props.banner
  let bannerPath = banner?.baFileDto?.filePath
  return (
    <MainContainer>
      <Bg src={process.env.REACT_APP_BASE_RESOURCES_API + bannerPath} />
      <TextsContainer>
        {/* <Text1>EAGON PRODUCT CATALOG</Text1> */}
        <Text2 dangerouslySetInnerHTML={{ __html: banner.baContents }}></Text2>
      </TextsContainer>
      {/*<LogoContainer>
        <Logo src={logo2Img} />
      </LogoContainer>*/}
    </MainContainer>
  )
}

export default Page0Mobile
const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 100vh;
  margin-bottom: 60.7px;
`
const Bg = styled.img`
  height: 100vh;
  object-fit: cover;
  z-index: 0;
`
const TextsContainer = styled.div`
  width: 100vw;
  height: 100vh;
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`
const Text1 = styled.p`
  font-family: GMarketSans;
  font-weight: medium;
  font-size: 11.7px;
  color: #fff;
  z-index: 300;
  text-align: center;
`
const Text2 = styled.p`
  font-family: Noto Sans KR;
  font-weight: normal;
  font-size: 30px;
  color: #fff;
  z-index: 300;
  text-align: center;
  margin-top: 10px;
  letter-spacing: -0.95px;
  line-height: 1.2;
`
const LogoContainer = styled.div`
  position: absolute;
  bottom: 30px;
  width: 100vw;
  display: flex;
  justify-content: center;
`
const Logo = styled.img`
  width: 142px;
  height: 19px;
`
